import React from "react";
import { Link } from "react-router-dom";
import { ClipboardCheck } from "lucide-react";
import ChatWidget from "./ChatWidget";

/**
 * Floating quick-actions dock — bottom right on tablet/desktop only.
 * "Ask Admissions" opens a live-chat window with quick reply options.
 * "Enroll Now" jumps to the multi-step application.
 * Hidden on mobile because the sticky bottom bar already provides Call / Ask / Apply.
 */
export default function FloatingActions() {
    return (
        <div
            className="hidden md:flex fixed bottom-6 right-6 z-40 flex-col items-end gap-2.5"
            aria-label="Quick actions"
            data-testid="floating-actions"
        >
            <ChatWidget />
            <Link
                to="/admissions/apply"
                className="group inline-flex items-center gap-2 rounded-full bg-lnl-green pl-3 pr-4 py-2.5 font-heading text-sm font-semibold text-white shadow-md hover:shadow-lg hover:bg-lnl-green-deep transition-shadow"
                data-testid="floating-enroll-now"
            >
                <span className="w-8 h-8 rounded-full bg-white/20 grid place-items-center">
                    <ClipboardCheck className="h-4 w-4 text-white" />
                </span>
                Enroll Now
            </Link>
        </div>
    );
}
